import { getFirestore, getCloudStorage } from '../../system/firebase';

import { format as formatDate } from 'date-fns';

import _get from 'lodash/get';
// import _set from 'lodash/set';

export const sendFileReply = ({ file, userId, threadId, setProgress, setIsUploading, onAttachmentUploadComplete }) => {
    console.log('uploading......');
    const storage = getCloudStorage();
    const name = _get(file, 'name');
    const timestampStr = formatDate(new Date(), 'yyyyMMddHHmmss_T');
    const storagePath = `users/${userId}/threads/${threadId}/${timestampStr}`;
    const uploadTask = storage.ref(`${storagePath}/${name}`).put(file, { customMetadata: { userId, threadId, key: timestampStr, originFilename: name, isMsgAttachment: true } });
    setIsUploading(true);
    uploadTask.on(
        'state_changed',
        snapshot => {
            // progress function ...
            const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            setProgress(progress);
        },
        error => {
            // Error function ...
            console.error('File upload failed', error);
        },
        async () => {
            // complete function ...
            try {
                const url = await storage.ref(storagePath).child(name).getDownloadURL();
                onAttachmentUploadComplete(file, url);
            } catch (error) {
                console.error('Failed to obtain file URL:', error);
            }
        },
    );
};

export const addThreadMessage = async ({ messageDto, setSnackbarMessage, setSnackbarErrorMessage, recipientName = 'Recipient', lastReadDtRef }) => {
    console.log({ messageDto, setSnackbarMessage, setSnackbarErrorMessage, recipientName });
    const db = getFirestore();

    // Separated new thread in to another function addThread().  So assumed when this function is called, threadId is never null.
    // if (!messageDto.threadId) {
    //     messageDto.threadId = nanoid();
    // }
    try {
        // add new threadMessage doc
        const threadMessagesRef = db.collection('threadMessages');
        await threadMessagesRef.add(messageDto);
        if (lastReadDtRef) lastReadDtRef.current = new Date(); // renew ThreadDetail lastReadDtRef each time user sent a message
        setSnackbarMessage(` Message was sent to ${recipientName} successfully`); // Do not implement Undo here!!!
    } catch (error) {
        console.error('Transaction failed when adding thread message:', error);
        setSnackbarErrorMessage('Failed to send message');
    }
};
export const addThreadMessageInternal = async ({ messageDto, setSnackbarMessage, setSnackbarErrorMessage, lastReadDtRef }) => {
    const db = getFirestore();
    try {
        // add new threadMessage doc
        const threadMessagesRef = db.collection('threadMessages');
        await threadMessagesRef.add(messageDto);
        if (lastReadDtRef) lastReadDtRef.current = new Date(); // renew ThreadDetail lastReadDtRef each time user sent a message
        setSnackbarMessage(` Message was sent successfully`);
    } catch (error) {
        console.error('Transaction failed when adding thread message:', error);
        setSnackbarErrorMessage('Failed to send message');
    }
};
export const uploadFile = ({ file, employerId, threadId, cb }) => {
    const storage = getCloudStorage();
    const name = _get(file, 'name');
    const timestampStr = formatDate(new Date(), 'yyyyMMddHHmmss_T');
    const storagePath = `users/${employerId}/threads/${threadId}/${timestampStr}`;
    const uploadTask = storage
        .ref(`${storagePath}/${name}`)
        .put(file, { customMetadata: { employerId, threadId, key: timestampStr, originFilename: name, isMsgAttachment: true } });

    uploadTask.on(
        'state_changed',
        (/*snapshot*/) => {
            // progress function ...
            // const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        },
        error => {
            // Error function ...
            console.error('File upload failed', error);
        },
        async () => {
            // complete function ...
            try {
                const url = await storage.ref(storagePath).child(name).getDownloadURL();
                cb(file, url);
            } catch (error) {
                console.error('Failed to obtain file URL:', error);
            }
        },
    );
};
